<script>

	import Header from './components/sections/Header.svelte';
	import Login from './components/sections/Login.svelte';
	import Register from './components/sections/Register.svelte';
	import Dashboard from './components/sections/Dashboard.svelte';
	import {isLoggedIn} from './components/stores/UserStore';
	import {sessionReady, restoreSession} from './functions/Session';

	import { build } from './build-meta.js';
	$: document.title = `b${build} | DeckBlox Games`;

	let currentView = 'login';
	let isAuthenticated = false;

	function handleLogin() {
		isAuthenticated = true;
	}

	function handleLogout() {
		isAuthenticated = false;
		currentView = 'login';
	}

	restoreSession();

</script>

<svelte:head>
	<link href="https://fonts.googleapis.com/css2?family=Open+Sans&display=swap" rel="stylesheet">
</svelte:head>

<Header/> 

{#if !$sessionReady}
	<p>Loading...</p> 
{:else if $isLoggedIn}
  <Dashboard onLogout={handleLogout} />
{:else}
  {#if currentView === 'login'}
    <Login onLogin={handleLogin} onNavigateToRegister={() => currentView = 'register'} />
  {:else if currentView === 'register'}
    <Register onNavigateToLogin={() => currentView = 'login'} />
  {/if}
{/if}


  